<template>
  <wrapper>
    <template slot="navigation">
      <menu-point :disableActiveClass="true" icon="chevron-left" to="events">Alle Events</menu-point>
      <div
        class="ml-3 font-semibold text-sm border-b border-gray-700 pb-1 mt-4 mb-2 text-gray-200"
      >Eventmanager</div>

      <menu-point to="events.dashboard">Überblick</menu-point>
      <menu-point to="events.orders">Bestellungen</menu-point>
      <menu-point to="events.finance">Finanzen</menu-point>

      <div class="ml-3 font-semibold text-sm border-b border-gray-700 pb-1 mt-4 mb-2 text-gray-200">
        <span>Eventeditor</span>
        <span class="bg-gray-600 rounded px-1 text-xs uppercase ml-2">Beta</span>
      </div>

      <menu-point to="events.details">Details</menu-point>

      <menu-point to="events.ticketDesign">Ticket-Design</menu-point>

      <menu-point v-if="event.is_reserved_seating" to="events.seats">Sitzplatzreservierung</menu-point>

      <!--<menu-point to="event.contingent">Kontingent</menu-point>-->
      <!--<menu-point to="event.contingent">Ticketdesign</menu-point>-->
      <!--<menu-point to="event.contingent">Benachrichtigungen</menu-point>-->

      <!--<div class="ml-4 font-bold text-sm mt-6 mb-2 pb-1 text-white border-b">Erstellen</div>-->

      <!--<menu-point to="event.details">Ticketbestellung</menu-point>-->
    </template>

    <template slot="page">
      <div v-if="loading" class="flex justify-center items-center h-full">
        <Loading class="h-screen" />
      </div>

      <router-view v-else :event="event"></router-view>
    </template>
  </wrapper>
</template>

<script>
import { MenuPoint, Wrapper } from "@/components/Wrapper";
import Loading from "@/components/Loading";

export default {
  components: {
    MenuPoint,
    Wrapper,
    Loading,
  },

  data() {
    return {
      loading: true,
    };
  },

  computed: {
    event() {
      return this.$store.state.editor.event;
    },
  },

  mounted() {
    this.$store
      .dispatch("editor/fetch", this.$route.params.id)
      .then(() => (this.loading = false));
  },
};
</script>
